import { Button } from "@nextui-org/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { PiArrowLeft, PiArrowRight } from "react-icons/pi";

interface QuizControlsProps {
  showCorrect: () => void;
  handleReset: () => void;
  handleSubmission: () => void;
  handlePreviousQuiz: () => void;
  handleNextQuiz: () => void;
  onClose: () => void;
  selectedQuiz: number;
  numberOfQuiz: number;
  maxTries: number;
  submitCount: number;
  correct: boolean;
}

const QuizControls: React.FC<QuizControlsProps> = (
  props: QuizControlsProps
) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-row justify-between w-full gap-4 mt-8">
      <div className="flex gap-2">
        {props.submitCount >= props.maxTries && (
          <Button
            color="success"
            size="sm"
            onPress={props.showCorrect}
            className="cursor-pointer"
          >
            {t("quiz_controls.show_answers")}
          </Button>
        )}
        <Button
          color="warning"
          size="sm"
          onPress={props.handleReset}
          className="cursor-pointer"
        >
          {t("quiz_controls.reset")}
        </Button>
        <Button
          color="primary"
          size="sm"
          onPress={props.handleSubmission}
          isDisabled={props.submitCount >= props.maxTries}
          className="cursor-pointer"
        >
          {t("quiz_controls.submit")}
        </Button>
        <span className="text-default-400 text-sm m-auto">
          {props.maxTries - props.submitCount}{" "}
          {t("quiz_controls.remaining_tries")}
        </span>
      </div>
      <div className="flex gap-2">
        <Button
          isDisabled={props.selectedQuiz === 0}
          size="sm"
          variant="light"
          onClick={props.handlePreviousQuiz}
          className="cursor-pointer"
        >
          <PiArrowLeft />
        </Button>
        <Button
          isDisabled={
            props.selectedQuiz === props.numberOfQuiz - 1 ||
            (!props.correct && props.submitCount < props.maxTries)
          }
          size="sm"
          onClick={props.handleNextQuiz}
          variant="light"
          className="cursor-pointer"
        >
          <PiArrowRight />
        </Button>
        {props.selectedQuiz === props.numberOfQuiz - 1 &&
          (props.correct || props.submitCount >= props.maxTries) && (
            <Button
              size="sm"
              color="primary"
              onPress={props.onClose}
              className="cursor-pointer"
            >
              {t("quiz_controls.close")}
            </Button>
          )}
      </div>
    </div>
  );
};

export default QuizControls;
